import "./OurTeam.css";

const team = [
  {
    name: "Dr. P. Sai Krishna",
    role: "BDS, MDS",
    speciality: "Oral Health & Root Canal Specialist",
    college: "Govt. Dental College, Hyderabad",
    initials: "SK",
    color: "#0a7c6e",
  },
  {
    name: "Dr. V. Vijaya Sagar",
    role: "BDS, MDS",
    speciality: "Cosmetic Dental Surgeon",
    college: "Govt. Dental College, Hyderabad",
    initials: "VS",
    color: "#12a090",
  },
];

export default function OurTeam() {
  return (
    <section className="team" id="team">
      <div className="team-inner">
        <div className="team-header">
          <span className="section-tag">Our Doctors</span>
          <h2 className="section-title">Meet Our Expert Team</h2>
          <p className="section-subtitle">
            Highly qualified specialists committed to your oral health and beautiful smile.
          </p>
        </div>

        <div className="team-grid">
          {team.map((member) => (
            <div key={member.name} className="team-card">
              <div className="team-avatar" style={{ background: `${member.color}22`, border: `2px solid ${member.color}33` }}>
                <span style={{ color: member.color }}>{member.initials}</span>
              </div>
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <span className="team-role">{member.role}</span>
                <p className="team-speciality">{member.speciality}</p>
                <p className="team-college">📍 {member.college}</p>
              </div>
              <div className="team-card-bottom">
                <a href="#contact" className="btn-outline" style={{ fontSize: "0.85rem", padding: "10px 24px" }}>
                  Book Appointment
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}